import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, ActivityIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { MobileNav } from './MobileNav';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const navItems = [{
    id: 'overview',
    label: 'Overview',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'metrics',
    label: 'Metrics',
    icon: BarChart2Icon,
    section: 'metrics',
    href: '#metrics'
  }, {
    id: 'timeline',
    label: 'Timeline',
    icon: ActivityIcon,
    section: 'timeline',
    href: '#timeline'
  }, {
    id: 'proof',
    label: 'Proof',
    icon: ShieldCheckIcon,
    section: 'proof',
    href: '#proof'
  }, {
    id: 'audience',
    label: 'Audience',
    icon: UsersIcon,
    section: 'audience',
    href: '#audience'
  }];
  const handleExport = () => {
    window.print();
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-[#FFFFFF] border-b border-[#E5E5E5] sticky top-0 z-50 print:static print:border-b-0" data-id="element-379">
      <div className="container mx-auto px-4 md:px-6" data-id="element-380">
        <div className="flex items-center justify-between h-16 print:h-auto print:py-4" data-id="element-381">
          <div className="flex items-center" data-id="element-382">
            <img src="https://cdn.magicpatterns.com/uploads/xigW7hwGMVUzDbg5ohfKU7/Lenovo_idDXuX8rvi_1.svg" alt="Lenovo" className="h-7 md:h-8 w-auto" data-id="element-383" />
          </div>

          <nav className="hidden md:flex items-center space-x-1 print:hidden" data-id="element-384">
            {navItems.map(item => {
            const Icon = item.icon;
            const isActive = activeItem === item.section;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-4 py-2 rounded-sm text-sm font-medium transition-all duration-200 ${isActive ? 'bg-[#C00000]/10 text-[#C00000]' : 'text-[#AAAAAA] hover:bg-[#F9FAFB] hover:text-[#171717]'}`} data-id="element-385">
                  <Icon className={`h-4 w-4 mr-2 ${isActive ? 'text-[#C00000]' : 'text-[#AAAAAA]'}`} data-id="element-386" />
                  {item.label}
                </a>;
          })}
          </nav>

          <div className="flex items-center space-x-3 print:hidden" data-id="element-387">
            <button onClick={handleExport} className="hidden md:flex items-center space-x-2 bg-[#FFFFFF] border border-[#E5E5E5] text-[#171717] px-4 py-2 text-sm font-medium hover:bg-[#F9FAFB] transition-colors" data-id="element-388">
              <FileDownIcon className="h-4 w-4" data-id="element-389" />
              <span data-id="element-390">Export PDF</span>
            </button>

            <a href="https://resonance.brandpulse-analytics.com/" target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex relative group whitespace-nowrap" data-id="element-391">
              <span className="flex items-center bg-[#0D5C91] text-white px-5 py-2.5 text-sm font-medium hover:bg-[#0D5C91]/90 transition-colors relative z-10" data-id="element-392">
                Create new
                <span className="ml-2 text-white transition-transform group-hover:translate-x-0.5" data-id="element-393">
                  ›
                </span>
              </span>
            </a>

            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-[#F9FAFB] rounded-sm transition-colors" data-id="element-394">
              <MenuIcon className="h-6 w-6 text-[#101010]" data-id="element-395" />
            </button>
          </div>
        </div>
      </div>

      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-396" />
    </header>;
};